import React from 'react';
import Link from 'next/link';
import { btnTypes } from '@ertelecom/ui-react/components/buttons/baseButton';
// @ts-ignore
import FormContainer from '@ertelecom/ui-react/components/layouts/formContainer';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import AuthFields from '~/src/components/Auth/auth-fields';
import NoSSR from '~/src/helpers/noSSR';
import ErrorMessage from '~/src/components/Login/ErrorMessage';
import { Container, GreyLink, GreyText, Header, WrapperContainer, PlContainer, Button } from './styled';

interface ILoginProps {
    headerText?: string;
    plAvailable?: boolean;
}

const Login = ({ headerText, plAvailable = false }: ILoginProps): JSX.Element => {
    return (
        <WrapperContainer plAvailable={plAvailable}>
            <GridContainer>
                <FormContainer maxWidth={'680px'} backgroundColor='none'>
                    <Container>
                        <Header> {headerText || 'Войти в личный кабинет'} </Header>
                        <NoSSR>
                            {/* @ts-ignore */}
                            <ErrorMessage/>
                        </NoSSR>

                        <AuthFields
                            noTabs={false}
                            buttonText='Войти'
                            showCheckBox={true}
                            showForgetLink={true}
                        />

                        <GreyText>
                            Нажимая кнопку «Войти», вы даете согласие
                            <br />
                            на обработку <GreyLink as='a' href='//dom.ru/policy.pdf' target='_blank'>персональных данных</GreyLink>
                        </GreyText>
                        <Link href={'/request'} passHref>
                            <Button type={btnTypes.OUTLINE} text='Стать клиентом'/>
                        </Link>
                    </Container>
                </FormContainer>
                {plAvailable && (
                    <PlContainer>
                        <img src='/static/images/loyalty/pl-card.png' alt='' />
                        <Link href='/domrubonus'>Подробнее</Link>
                    </PlContainer>
                )}
            </GridContainer>
        </WrapperContainer>
    );
};

export default Login;
